export enum MessageBoardType {
  // NEW_USER_ENTRY = 'newUserGuide',
  NEW_USER_TASK = 'newUserTask',
  NEW_USER_TASK_COMPLETED_STUDENT = 'newUserTaskCompletedStudent',
  NEW_USER_TASK_COMPLETED_NOT_STUDENT = 'newUserTaskCompletedNotStudent',
  NEW_USER_TASK_COMPLETED_AUTHENTICATION_STUDENT = 'newUserTaskCompletedAuthenticationStudent',
  EDUCATION_AUTHENTICATION = 'educationAuthentication',
  // CLOSE_SETTINGS_WITHOUT_UPGRADE = 'closeSettingsWithoutUpgrade', // 获得教育优惠
  // UPLOAD_FILE_BIGGER_THAN_1GB = 'uploadFileBiggerThan1GB', // 升级个人专业版
}

// 需求：https://flowus.cn/bc35dc67-5572-4ede-ab25-a9eab7f19240
